import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { connect } from "react-redux";
import windowSize from "react-window-size";

import Loader from "./layout/Loader";
import routes from "../route";

import Header from "../component/Header";
import Footer from "../component/Footer";

const App = props => {
    const [menus, setMenus] = useState([]);

    useEffect(() => {
        let menu = [];
        for (const key in routes) {
            const subMenu = routes[key].map((route, index) => {
                return route.component ? <Route path={"/" + key + route.path} exact={route.exact} name={route.name} element={route.component} /> : null;
            });
            menu = menu.concat(subMenu);
        }
        setMenus(menu);
    }, []);

    return (
        // <div className="lal">

        <Suspense fallback={<Loader />}>
            <Header />
            <Routes>
                {menus}
                <Route path="/" element={<Navigate to="/main/info" replace />} />
            </Routes>
            <Footer />
        </Suspense>

        // </div>
    );
};

// const mapStateToProps = state => {
//     return {
//         defaultPath: state.defaultPath
//     };
// };

// const mapDispatchToProps = dispatch => {
//     return {
//         // onFullScreenExit: () => dispatch({ type: actionTypes.FULL_SCREEN_EXIT })
//     };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(App));
export default windowSize(App);
